import React, { useState } from 'react';
import { Card, Form, Input, Button, Space, Typography, Alert, Divider } from 'antd';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';
import SipuniExtensionField from './SipuniExtensionField';

const { Title, Text } = Typography;

/**
 * Компонент для тестирования интеграции Sipuni
 * Можно использовать для проверки работы компонента
 */
const TestSipuniIntegration = () => {
  const [form] = Form.useForm();
  const [sipuniExtension, setSipuniExtension] = useState('');
  const [sipuniEnabled, setSipuniEnabled] = useState(true);
  const [testResult, setTestResult] = useState(null);

  const handleTest = (values) => {
    const testData = {
      ...values,
      sipuniExtension,
      sipuniEnabled,
      timestamp: new Date().toISOString()
    };

    setTestResult({
      success: true,
      message: 'Тест прошел успешно!',
      data: testData
    });

    console.log('Test Sipuni Integration:', testData);
  };

  const handleReset = () => {
    form.resetFields();
    setSipuniExtension('');
    setSipuniEnabled(true);
    setTestResult(null);
  };

  return (
    <Card 
      title="🧪 Тест интеграции Sipuni" 
      style={{ maxWidth: 600, margin: '20px auto' }}
      extra={
        <Button onClick={handleReset} size="small">
          Сбросить
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleTest}
        initialValues={{
          name: 'Тест',
          surname: 'Пользователь',
          phone: '+77771234567'
        }}
      >
        <Title level={5}>
          <UserOutlined style={{ marginRight: '8px' }} />
          Основная информация
        </Title>

        <Form.Item
          name="name"
          label="Имя"
          rules={[{ required: true, message: 'Введите имя' }]}
        >
          <Input placeholder="Введите имя" />
        </Form.Item>

        <Form.Item
          name="surname"
          label="Фамилия"
          rules={[{ required: true, message: 'Введите фамилию' }]}
        >
          <Input placeholder="Введите фамилию" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Номер телефона"
          rules={[{ required: true, message: 'Введите номер телефона' }]}
        >
          <Input 
            prefix={<PhoneOutlined />}
            placeholder="+77771234567" 
          />
        </Form.Item>

        <Divider orientation="left">📞 Настройки Sipuni</Divider>

        <Form.Item label="Внутренний номер Sipuni">
          <SipuniExtensionField
            value={sipuniExtension}
            onChange={setSipuniExtension}
            userPhone={form.getFieldValue('phone')}
            userName={`${form.getFieldValue('surname') || ''} ${form.getFieldValue('name') || ''}`.trim()}
            required={false}
          />
        </Form.Item>

        <Form.Item>
          <label>
            <input
              type="checkbox"
              checked={sipuniEnabled}
              onChange={(e) => setSipuniEnabled(e.target.checked)}
              style={{ marginRight: '8px' }}
            />
            Включить интеграцию с телефонией Sipuni
          </label>
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Протестировать
            </Button>
            <Button onClick={handleReset}>
              Сбросить
            </Button>
          </Space>
        </Form.Item>
      </Form>

      {testResult && (
        <Alert
          message={testResult.message}
          type={testResult.success ? 'success' : 'error'}
          showIcon
          style={{ marginTop: '16px' }}
          description={
            <div>
              <Text strong>Данные для отправки:</Text>
              <pre style={{ 
                background: '#f5f5f5', 
                padding: '8px', 
                borderRadius: '4px', 
                marginTop: '8px',
                fontSize: '12px',
                overflow: 'auto'
              }}>
                {JSON.stringify(testResult.data, null, 2)}
              </pre>
            </div>
          }
        />
      )}

      <Divider />

      <div style={{ fontSize: '12px', color: '#666' }}>
        <Text strong>Инструкции для тестирования:</Text>
        <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
          <li>Заполните основные поля (имя, фамилия, телефон)</li>
          <li>Нажмите "Предложить" для получения рекомендаций номеров</li>
          <li>Выберите внутренний номер из списка</li>
          <li>Нажмите "Протестировать" для проверки данных</li>
          <li>Проверьте консоль браузера для дополнительной отладочной информации</li>
        </ul>
        
        <Text strong style={{ display: 'block', marginTop: '12px' }}>
          Ожидаемые API endpoints на бэкенде:
        </Text>
        <ul style={{ marginTop: '4px', paddingLeft: '20px' }}>
          <li><code>GET /api/sipuni/admin/available-extensions</code></li>
          <li><code>POST /api/sipuni/admin/suggest-by-phone</code></li>
          <li><code>POST /api/user</code> (обновленный с полями Sipuni)</li>
        </ul>
      </div>
    </Card>
  );
};

export default TestSipuniIntegration;
